import $, { ajaxSetup } from "jquery";
window.jQuery = $;
window.$ = $;

import "lazysizes";
// import Swup from "swup";
// import SwupBodyClassPlugin from "@swup/body-class-plugin";
// import SwupScrollPlugin from "@swup/scroll-plugin";

// import { collapsibleText } from "./components/collapsible-text";
// import { floatingImages } from "./components/floating-images";
import sal from "sal.js";
import { filters } from "./components/filters";
import { filtersNews } from "./components/filters-news";
import { nav } from "./components/nav";
import { collapsible } from "./components/collapsible";
import { map } from "./components/map";
import { counters } from "./components/counters";
// import { artistHero } from "./components/artist-hero";

const windowMain = window.main || {};
let links = document.querySelectorAll(
  "a, a *, .has-cursor-link-state, .has-cursor-link-state *, input, textarea, button, .js-collapsible-row, .t-link"
);

const $mobileNav = $(".js-mobile-nav");

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;

function checkIfTouchDevice() {
  return (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  );
}

function swupReload() {

  document.body.setAttribute("data-menu-open", "false");
  document.body.setAttribute("data-overlay-open", "false");
  document.body.classList.remove("no-scroll");
  links = document.querySelectorAll(
    "a, a *, .has-cursor-link-state, .has-cursor-link-state *, input, textarea, button, .js-collapsible-row, .t-link"
  );

  $mobileNav.attr("aria-hidden", true);
  isNavToggled = false;

  sal({
    threshold: 0.01,
    once: true,
  });
  
  // if (!isTouchDevice) {
  //   floatingImages();
  // }
  // collapsibleText();
  filters();
  filtersNews();
  nav(isNavToggled);
  map(".js-map");
  collapsible();
  counters();
  // artistHero();

}

function loadHeroVideo() {
  // Check if the viewport matches mobile or desktop
  const isMobile = window.matchMedia("(max-width: 640px)").matches;

  // Select the hero sections
  const mobileHero = document.querySelector(".c-home-hero--mobile");
  const desktopHero = document.querySelector(".c-home-hero--desktop");

  // Determine which hero to show
  const heroToShow = isMobile ? mobileHero : desktopHero;
  const heroToHide = isMobile ? desktopHero : mobileHero;

  // Hide the other hero section
  if (heroToHide) {
    heroToHide.style.display = "none";

    // Remove the video `src` to stop loading the unused video
    const video = heroToHide.querySelector("video");
    if (video) {
      video.removeAttribute("src");
      video.load(); // Ensures the browser stops trying to load the video
    }
  }

  // Show the appropriate hero section
  if (heroToShow) {
    heroToShow.style.display = "block";

    // Lazy-load the video for the visible hero
    const video = heroToShow.querySelector("video");
    if (video && video.dataset.src && !video.src) {
      video.src = video.dataset.src; // Assign `src` only if not already set
      video.load();
    }
  }
}

function init() {
  sal({
    threshold: 0.01,
    once: true,
  });
  if (history.scrollRestoration) history.scrollRestoration = "manual";

  filters();
  filtersNews();
  nav(isNavToggled);
  map(".js-map");
  collapsible();
  counters();

  document.addEventListener("DOMContentLoaded", loadHeroVideo);
  window.addEventListener("resize", loadHeroVideo);

}

function setupPlugins() {

  const swup = new Swup({
    animationSelector: '[class*="transition-"]',
    containers: ["#swup", "#swup-header", "#swup-footer"],
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupScrollPlugin({
        doScrollingRightAway: false,
        animateScroll: false,
        scrollFriction: 0,
        scrollAcceleration: 0,
      }),
    ],
  });
  swup.on("contentReplaced", () => {
    checks();
    swupReload();
  });
}

function checks() {
  isTouchDevice = checkIfTouchDevice();
  if (isTouchDevice) {
    document.documentElement.classList.add("is-touch");
  }
  isHomepage = document.body.classList.contains("page-home");
}



// function stickyOrNot() {
//   // Get all elements with class .sticky
//   var stickyElements = document.querySelectorAll(".sticky");

//   // Loop through each element
//   stickyElements.forEach(function (element) {
//     if (document.documentElement.clientHeight < element.offsetHeight + 100) {
//       element.style.marginTop = "100px";
//       element.style.position = "relative";
//       //set zindex to 2 so that it is above the sticky header
//       element.style.zIndex = "2";
//     } else {
//       element.style.position = "sticky";
//       element.style.zIndex = "0";
//     }
//   });
// }

// stickyOrNot();

checks();
// Dont'run swup for now
// setupPlugins();
init();
